module.exports = __webpack_public_path__ + "static/media/search.f25442ae.svg";